var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b',[_vm._v("#"+_vm._s(_vm.item.id_curso)+" - ")]),_c('span',[_vm._v(_vm._s(_vm.item.nome_curso ? _vm.item.nome_curso : _vm.item.nome_curso_mae))])])
}
var staticRenderFns = []

export { render, staticRenderFns }